module.exports = __webpack_public_path__ + "img/grid.bb944c4e.svg";